import React, { useEffect } from 'react';
import { useCaptions } from '@/context/caption-context/use-captions';
import { cn } from '@/lib/utils.ts';
import { UserPlan } from '@/models';

import { useAuth } from '@/context/auth-context/use-auth.ts';
import { API_BASE } from '@/config.ts';
import { CaptionsIcon } from 'lucide-react';
import { ActionTooltip } from "@/components/action-tooltip.tsx";

interface CaptionToggleButtonProps {
  className?: string;
}

export function CaptionToggleButton({ className }: CaptionToggleButtonProps) {
  const { captionsEnabled, toggleCaptions } = useCaptions();

  return (
    <ActionTooltip label={captionsEnabled ? 'Выключить субтитры' : 'Включить субтитры'} side="top">
      <button
        type="button"
        onClick={toggleCaptions}
        aria-pressed={captionsEnabled}
        className={cn('h-9 pointer-events-auto', 'text-xs font-semibold text-white', className)}
      >
        <span
          className={cn(
            'h-full items-center flex rounded px-1.5 py-0.5 text-[10px] font-bold leading-none',
            captionsEnabled
              ? 'bg-blue-500/80 text-white'
              : ' bg-foreground-100  text-white/80 text-black dark:text-white'
          )}
        >
          <CaptionsIcon />
        </span>

        {/*{captionsEnabled ? 'Субтитры вкл' : 'Субтитры выкл'}*/}
      </button>
    </ActionTooltip>
  );
}
